import React from 'react'
import Button from 'react-bootstrap/esm/Button'
import Helpers from '../../Components/Helpers/Helpers'

const Encuesta2Form = ({ data }) => {
    return <>
        <Button variant='danger' size="sm" onClick={_ => {
            Helpers.print.construct({
                selector: '#frm_encuesta_detalle',
                title: 'Encuesta'
            })
        }}>
            <i className='fa fa-print mr-2'></i> Imprimir
        </Button>
        <div className='form-row' id="frm_encuesta_detalle">
            <div className="col-12">
                <div className="text-center mb-2">
                    <h6 className='text-primary'>
                        <strong>Calificación Final</strong>
                    </h6>
                </div>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Nombres</th>
                                <th>Edad</th>
                                <th>Puesto</th>
                                <th>Calificación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='text-center'>
                                    {data.encuesta.name_user}
                                </td>
                                <td className='text-center'>
                                    {data.encuesta.age_user}
                                </td>
                                <td className='text-center'>
                                    {data.encuesta.job_user}
                                </td>
                                <td className='text-center'>
                                    <span className="badge" style={{
                                        background: data.encuesta.calification_color,
                                        color: data.encuesta.calification_color_text
                                    }}>{data.encuesta.calification}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="text-center mb-2">
                    <h6 className='text-primary'>
                        <strong>Detalle Respuestas</strong>
                    </h6>
                </div>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Pregunta</th>
                                <th>Respuesta</th>
                            </tr>
                        </thead>
                        <tbody>
                            {React.Children.toArray(data.questions.map((sec) => {
                                return sec.items.map(it => {
                                    return <tr>
                                        <td className='text-center'>{it.title}</td>
                                        <td className='text-center'>
                                            <strong>{it.answer}</strong>
                                        </td>
                                    </tr>
                                })
                            }))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </>
}

export default Encuesta2Form;